var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "bg-white p-6 pt-0" },
    [
      _c(
        "LoadingOverlay",
        { attrs: { hasData: _vm.hasData, loading: _vm.loading } },
        [
          _vm.loading
            ? _c(
                "div",
                {
                  staticClass: "w-full flex justify-center items-center h-full",
                },
                [_c("Spinner")],
                1
              )
            : _c(
                "div",
                [
                  !_vm.loading && _vm.isEmptyList
                    ? _c(
                        "EmptyListPlaceholder",
                        {
                          attrs: { title: "There are no groups at the moment" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "image",
                                fn: function () {
                                  return [_c("EmptyListImageRequests")]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2557147869
                          ),
                        },
                        [
                          _c("UiButton", {
                            attrs: {
                              buttonText: "Create Group",
                              variant: "outline-black",
                              buttonClasses: "px-2 pr-5 pl-3.5 mt-2 mx-2",
                            },
                            on: {
                              click: function ($event) {
                                _vm.modalShown = true
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "icon",
                                  fn: function () {
                                    return [
                                      _c("PlusIcon", {
                                        staticClass: "w-4 h-4",
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "hover-icon",
                                  fn: function () {
                                    return [
                                      _c("PlusIcon", {
                                        staticClass: "w-4 h-4",
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              3411302018
                            ),
                          }),
                        ],
                        1
                      )
                    : _c("div", [
                        _c(
                          "div",
                          {},
                          [
                            _c("GroupCollectionFilters", {
                              attrs: {
                                hideManagersFilter: !_vm.isAdmin,
                                userRole: _vm.currentUser.role,
                                userId: _vm.currentUser.id,
                                managerId: _vm.currentManagerId,
                                managerAccessContractorsIds:
                                  _vm.managerAccessContractorsIds,
                                companyId: _vm.company.id,
                                filters: _vm.groupFilters,
                              },
                              on: {
                                filtersChanged: _vm.updateFilters,
                                filtersReset: _vm.resetFilters,
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "flex justify-end mb-6 mt-5" },
                          [
                            _c("UiButton", {
                              attrs: {
                                buttonText: "Create Group",
                                variant: "outline-black",
                                buttonClasses: "px-2 pr-5 pl-3.5 mt-2 mx-2",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.modalShown = true
                                },
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "icon",
                                  fn: function () {
                                    return [
                                      _c("PlusIcon", {
                                        staticClass: "w-4 h-4",
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "hover-icon",
                                  fn: function () {
                                    return [
                                      _c("PlusIcon", {
                                        staticClass: "w-4 h-4",
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                        _vm.isData
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass: "flex flex-wrap gap-4 p-4 pt-0",
                                },
                                _vm._l(_vm.groups, function (group) {
                                  return _c("GroupCard", {
                                    key: group.id,
                                    attrs: {
                                      group: group,
                                      companyId: _vm.company.id,
                                      currentUser: _vm.currentUser,
                                      name: group.name,
                                      groupId: group.id,
                                      managers: group.managers,
                                      postings: group.postings,
                                      contractors: group.contractors,
                                      projects: group.projects,
                                      skills: group.skills,
                                      active: group.active,
                                      location: group.location,
                                      archived: group.archived,
                                      isAdmin: _vm.isAdmin,
                                    },
                                    on: { refetch: _vm.handleRefetch },
                                  })
                                }),
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "p-4" },
                                [
                                  _c("CardPagination", {
                                    attrs: { config: _vm.paginationConfig },
                                    on: {
                                      "update:config": function ($event) {
                                        _vm.paginationConfig = $event
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ])
                          : _c(
                              "div",
                              [
                                _c("EmptyListPlaceholder", {
                                  attrs: { title: "No groups found." },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "image",
                                      fn: function () {
                                        return [_c("EmptyListImageRequests")]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                }),
                              ],
                              1
                            ),
                      ]),
                ],
                1
              ),
          _vm.modalShown
            ? _c("GroupModal", {
                attrs: {
                  data: _vm.selectedGroup,
                  currentUser: _vm.currentUser,
                  dialog: _vm.modalShown,
                  companyId: _vm.company.id,
                },
                on: {
                  refetch: _vm.handleRefetch,
                  close: function ($event) {
                    _vm.modalShown = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }